import { createContext, useCallback, useEffect, useMemo, useState } from 'react'

import { authService } from '@/auth/authService'

export const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [session, setSession] = useState({
    authenticated: false,
    user: null,
    subscription: null,
    usage: null,
    ideSessionId: null,
    governedRuntime: null,
    recentProjects: [],
  })
  const [bootstrapping, setBootstrapping] = useState(true)

  const bootstrap = useCallback(async () => {
    setBootstrapping(true)
    try {
      const nextSession = await authService.bootstrap()
      setSession(nextSession)
    } catch (err) {
      console.warn('Failed to bootstrap session (are you running outside Electron?):', err.message)
    } finally {
      setBootstrapping(false)
    }
  }, [])

  useEffect(() => {
    void bootstrap()
  }, [bootstrap])

  const login = useCallback(async credentials => {
    const nextSession = await authService.login(credentials)
    setSession(nextSession)
    return nextSession
  }, [])

  const logout = useCallback(async () => {
    await authService.logout()
    setSession({
      authenticated: false,
      user: null,
      subscription: null,
      usage: null,
      ideSessionId: null,
      governedRuntime: null,
      recentProjects: [],
    })
  }, [])

  const value = useMemo(
    () => ({
      session,
      bootstrapping,
      login,
      logout,
      refreshSession: bootstrap,
    }),
    [bootstrap, bootstrapping, login, logout, session]
  )

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
